import React from 'react'
import {HandlePageWelcome} from '../../../../../context/HandlePageWelcome'
import {MDBBtn, MDBContainer, MDBTypography} from 'mdb-react-ui-kit'
import {AiFillCaretLeft, AiFillCaretRight} from 'react-icons/ai'
import {FiUmbrella} from 'react-icons/fi'

const LevelOne = () => {
  const {page, setPage} = React.useContext(HandlePageWelcome)
  return (
      <div style={{ height: '95%' }} dir={'rtl'} className={'flex mt-5 flex-col justify-between'}>
       <div>
         <h1 className={'text-white text-5xl '}>خوش آمدید !</h1>
         <br />
         <div className={'mt-4 mb-4 text-center text-white'}>
           <FiUmbrella size={150} />
         </div>
         <br />
         <p className={'text-white mt-5 text-2xl font-light'}>
           کم ریسک ترین سهام ممکن را خریداری کنید تا سرمایه خود را برای آینده ذخیره کنید
           .
         </p>
       </div>
        <div className={'text-white mt-5 mb-2'}>
          <ul className={'leading-9'}>
            <li>بدون ریسک و ÷بازدهی بالا </li>
            <li>بیمه تکمیلی برای سهامدار و  </li>
            <li>حق استخدام </li>
            <li>درمان رایگان و با سود سالانه</li>
          </ul>
        </div>
        <div className={'mt-5 text-left'}>
          <MDBBtn color='light' className={'rounded-lg'} icon='download' onClick={() => setPage(2)}>
            مرحله بعد
            <AiFillCaretLeft />
          </MDBBtn>
        </div>
      </div>
  )
}

export default LevelOne